<section>
  <ness-info-report-notification *ngIf="submitted" [notification]="submitNotification" (sublinkClicked)="clickLink($event)"></ness-info-report-notification>
  <div class="d-flex justify-content-center" *ngIf="!submitted">
    <div class="alert alert-light font-size-sm" role="alert">
      <i class="fas fa-info-circle fa-md" aria-hidden="true"></i> Click Previous or a Progress icon to edit the information report before submission.
    </div>
  </div>
  <h2>Review</h2>
  <p-messages [(value)]="msgs" [closable]="false"></p-messages>

  <form novalidate>
    <ness-info-report-notification [notification]="trackingNotification" (sublinkClicked)="clickLink($event)"></ness-info-report-notification>
    <ness-info-report-notification [notification]="eventsLeadsNotification" (sublinkClicked)="clickLink($event)"></ness-info-report-notification>
    <ness-info-report-notification [notification]="summaryNotification" (sublinkClicked)="clickLink($event)"></ness-info-report-notification>
  </form>
</section>
